<template>
  <div class="modal_reports">
    <div class="header">
      <h4 class="title">
        Параметры отчёта
      </h4>
    </div>

    <div class="line">
      <div class="elem">
        <fg-input
            v-model="report_params.report_name"
            :label="translate('reports.name')"
            :placeholder="translate('reports.name')"
            :maxlength="255"
        />
      </div>
    </div>

    <div class="line" v-if="metric_options.requires_period">
      <div class="elem">
        <WrapDatePicker
            type="date"
            value_type="YYYY-MM-DD"
            placeholder="Период"
            label="Период"
            v-model="report_params.date"
            :range="true"
            :confirm="true"
        />
      </div>
    </div>

    <div class="line">
      <div class="elem">
        <label> Метрики </label>
        <tree-select
            :options="metric_list"
            placeholder="Метрики"
            v-model="report_params.metric"
            :multiple="false"
            :clearable="false"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line" v-if="column_list.length">
      <div class="elem">
        <label> Колонки </label>
        <tree-select
            :options="column_list"
            placeholder="Колонки"
            v-model="report_params.columns"
            :multiple="true"
            :clearable="false"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line" v-if="aggregate_list.length">
      <div class="elem">
        <label> Параметры </label>
        <tree-select
            :options="aggregate_list"
            placeholder="Параметры"
            v-model="report_params.aggregates"
            :multiple="true"
            :clearable="false"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line" v-if="period_list.length">
      <div class="elem">
        <label> Период группировки данных </label>
        <tree-select
          :options="period_list"
          placeholder="Период группировки данных"
          v-model="report_params.period"
          :multiple="false"
          :clearable="false"
          :max-height="200"
        />
      </div>
    </div>

    <div class="line" v-if="metric_options.selection === 'server'">
      <div class="elem">
        <label>{{ translate('reports.servers') }}</label>
        <tree-select
            v-model="report_params.server_ips"
            :options="server_list"
            :placeholder="translate('reports.servers')"
            :multiple="true"
            :max-height="200"
        />
      </div>
    </div>

    <div class="line" v-for="key in parameter_filters" :key="key">
      <div class="elem">
        <fg-input
            v-model="report_params.filters[key]"
            :label="translate('reports.filter_' + key)"
            :placeholder="translate('reports.comma_separated')"
        />
      </div>
    </div>

    <div class="text-center buttons">
      <button
        class="btn btn-info btn-fill btn-wd marginButton"
        :disabled="!can_submit"
        @click.prevent="get_reports"
      >
        Запросить
      </button>
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "ModalReports",
  components: {WrapDatePicker},
  props: {
    device_ids: { type: Array, default: () => [] },
    filter: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      submitting: false,
      report_params: {
        report_name: '',
        metric: null,
        date: null,
        period: "day",
        columns: [],
        aggregates: [],
        format: null,
        max_attempts: null,
        server_ips: [],
        filters: {}
      },
    }
  },

  computed:{
    reports_options() {
      return this.$store.getters.getReportsOptions
    },
    metric_options() {
      return this.reports_options.metrics[this.report_params.metric] || {}
    },
    parameter_options() {
      return this.metric_options.parameters || {}
    },
    request_fields() {
      return this.metric_options.request_fields || []
    },
    parameter_filters() {
      return this.parameter_options.filters || []
    },
    can_submit() {
      if (this.submitting || !this.metric_options.selection) return false
      if (this.metric_options.selection === 'single_device' && this.device_ids.length !== 1) return false
      if (this.metric_options.selection === 'server' && !this.report_params.server_ips.length) return false
      if (this.request_fields.includes('format') && !this.reports_options.formats.includes(this.report_params.format)) return false
      if (this.request_fields.includes('max_attempts') && (!Number.isInteger(Number(this.report_params.max_attempts)) || Number(this.report_params.max_attempts) < 1)) return false
      if (this.parameter_filters.includes('instance_port') && this.filter_values('instance_port').some(port => !Number.isInteger(port) || port < 1 || port > 65535)) return false
      if (!this.metric_options.requires_period) return true
      const date = this.report_params.date
      return Array.isArray(date) && date.length === 2
          && date.every(value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value))
          && date[1] >= date[0]
    },
    request_params() {
      let selection = {}
      if (this.metric_options.selection === 'single_device') {
        selection = { device_id: this.device_ids[0] }
      } else if (this.metric_options.selection === 'multiple_devices') {
        selection = this.device_ids.length
            ? { device_ids: [...this.device_ids] }
            : JSON.parse(JSON.stringify(this.filter))
      }
      const parameters = {}
      for (const key of ['columns', 'aggregates']) {
        if (this.parameter_options[key]?.length) {
          parameters[key] = this.report_params[key].filter(value => this.parameter_options[key].includes(value))
        }
      }
      if (this.parameter_options.period?.length) parameters.period = this.report_params.period
      if (Object.prototype.hasOwnProperty.call(this.parameter_options, 'server_ips')) parameters.server_ips = [...this.report_params.server_ips]
      if (this.parameter_filters.length) {
        parameters.filters = {}
        this.parameter_filters.forEach(key => {
          const values = this.filter_values(key)
          if (values.length) parameters.filters[key] = values
        })
      }
      const params = {
        ...selection,
        report_name: this.report_params.report_name,
        metric: this.report_params.metric,
        format: this.report_params.format,
        max_attempts: Number(this.report_params.max_attempts),
        parameters
      }
      if (this.metric_options.requires_period) {
        params.date_from = this.report_params.date?.[0]
        params.date_to = this.report_params.date?.[1]
      }
      return Object.keys(params).reduce((result, key) => {
        if (this.request_fields.includes(key)) result[key] = params[key]
        return result
      }, {})
    },
    period_list() {
      const labels = { day: 'День', month: 'Месяц' }
      return (this.parameter_options.period || []).map(id => ({ id, label: labels[id] || id }))
    },
    metric_list() {
      return Object.keys(this.reports_options.metrics).map(id => {
        const single_device = this.reports_options.metrics[id].selection === 'single_device'
        return {
          id,
          label: id + (single_device ? ' (' + this.translate('reports.single_device') + ')' : ''),
          isDisabled: single_device && this.device_ids.length !== 1
        }
      })
    },
    column_list() {
      const labels = {
        'device.device_id': 'ID',
        'device.deviceGroup.name': 'Group',
        'device.placeOrLocation': 'Location',
        'device.activeTariffication.status': 'Tariffication',
        'device.deviceUptime.status': 'Uptime'
      }
      return (this.parameter_options.columns || []).map(id => ({ id, label: labels[id] || id }))
    },
    aggregate_list() {
      return (this.parameter_options.aggregates || []).map(id => ({ id, label: id }))
    },
    format_list() {
      return this.reports_options.formats.map(id => ({ id, label: id }))
    },
    server_list() {
      return this.$store.getters.getServerList.reduce((servers, server) => {
        const ip = server.ip || server.name?.match(/\(([^()]+)\)\s*$/)?.[1]
        if (ip && !servers.some(item => item.id === ip)) {
          servers.push({ id: ip, label: server.name })
        }
        return servers
      }, [])
    }
  },

  watch: {
    reports_options: {
      immediate: true,
      handler() {
        const available = this.metric_list.filter(metric => !metric.isDisabled)
        if (!available.some(metric => metric.id === this.report_params.metric)) {
          this.report_params.metric = available.find(metric => metric.id === 'device_traffic')?.id || available[0]?.id || null
        }
        this.report_params.format = this.reports_options.defaults.format || this.reports_options.formats[0] || null
        this.report_params.max_attempts = this.reports_options.defaults.max_attempts
        this.reset_parameters()
      }
    },
    'report_params.metric'() {
      this.reset_parameters()
    }
  },

  methods: {
    reset_parameters() {
      this.report_params.columns = this.report_params.columns.filter(value => (this.parameter_options.columns || []).includes(value))
      this.report_params.aggregates = this.report_params.aggregates.filter(value => (this.parameter_options.aggregates || []).includes(value))
      const periods = this.parameter_options.period || []
      if (!periods.includes(this.report_params.period)) this.report_params.period = periods.includes('day') ? 'day' : periods[0] || null
      this.report_params.filters = Object.fromEntries(this.parameter_filters.map(key => [key, '']))
      this.report_params.server_ips = []
    },
    filter_values(key) {
      const values = (this.report_params.filters[key] || '').split(/[,\s]+/).filter(Boolean)
      return key === 'instance_port' ? values.map(Number) : values
    },
    cancel () {
      this.$emit('close')
    },
    get_reports(){
      if (!this.can_submit) return
      this.submitting = true
      this.$http.v1.createReports(this.request_params, (response) => {
        if (response.data) {
          this.global_notify('info', this.translate('reports.created'))
          this.$emit('update', response.data)
          this.$emit('close')
        }else{
          this.global_notify('danger', this.translate('reports.create_error'))
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.modal_reports {
  padding: 10px;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      margin: 10px 0;
    }
  }

  .line {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .elem {
      width: 100%;
      min-width: 0;

      .vue-treeselect {
        margin-bottom: 10px;
      }
    }
  }

  .marginButton {
    margin: 5px;
  }
}
</style>
